import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterStorageService} from '../../services/filter-storage.service';
import {CreateProductRequestModel} from '../../api/create-product-request-model';
import {ProductsService} from '../../api/products.service';
import {ProgressService} from '../../controls/progress.service';
import {Subscription} from 'rxjs';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import * as $ from 'jquery';

@Component({
  selector: 'app-product-create',
  templateUrl: './product-create.component.html',
  styleUrls: ['./product-create.component.scss']
})
export class ProductCreateComponent implements OnInit, OnDestroy {

  constructor(private route: ActivatedRoute,
              private router: Router,
              private products: ProductsService,
              private progress: ProgressService,
              private filters: FilterStorageService) { }
  item: CreateProductRequestModel;
  private sub1: Subscription;
  types = ['Ingredient', 'Developer', 'Additive'];

  public uploader: FileUploader;

  public hasBaseDropZoneOver = false;

  ngOnInit() {
    this.item = new CreateProductRequestModel();
    this.sub1 = this.route.queryParams.subscribe((params: {categoryId: string}) => {
      console.log('categoryId', params);
      this.item.categoryId = params.categoryId;
      this.item.executorId = 'notemptystring';
      this.item.calc = 'X*1';
      this.item.size = 1;
    });

    this.uploader = new FileUploader({url: `/api/images`});
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      return this.onSuccessItem(item, response, status, headers);
    };
    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      return this.onErrorItem(item, response, status, headers);
    };
  }

  fileSelected($event: File[]) {
    this.progress.show();
    this.uploader.uploadAll();
  }

  private onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
    this.progress.hide();
    this.item.imageUrl = JSON.parse(response).result;
  }

  private onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
    // $('#reset-file-uploader').click();
    this.progress.hide();
    const messageResponse = JSON.parse(response);

    if (messageResponse.message != null) {
      alert(messageResponse.message);
      return;
    }
  }

  public fileOverBase(e: boolean): void {
    this.hasBaseDropZoneOver = e;
    console.log(e);
  }

  async saveData() {
    if (!this.validate()) {
      return ;
    }

    this.progress.show();

    try {
      await this.products.create(this.filters.getSelectedOrganization().id, this.item).toPromise();
      this.goBack();
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      this.progress.hide();
    }
  }

  private validate() {
    if (this.item.categoryId == null) {
      alert('Category is not specified');
      return false;
    }

    if (this.item.name == null || this.item.name.trim() === '') {
      alert('Specify name');
      return false;
    }

    if (this.item.uniqueCode == null) {
      alert('UPC/EIN is not specified');
      return false;
    }

    if (this.item.type == null) {
      alert('Type is not specified');
      return false;
    }

    if (this.item.size < 1) {
      alert('Size should be 1 or greater');
      return false;
    }

    return true;
  }

  goBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }

  ngOnDestroy(): void {
    this.sub1.unsubscribe();
  }
}
